export default __webpack_public_path__ + "static/media/purina.cfbb794d.png";